import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0663fc88"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0663fc88')) {
      api.createRecord('0663fc88', component.options)
    } else {
      api.reload('0663fc88', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0663fc88", function () {
      api.rerender('0663fc88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/operations/Index.vue"
export default component.exports